import { WORKFLOW_TYPES, WORKFLOW_CONFIG } from 'src/enums/EOutbound';
import { safeJSONParse } from '@/utils/helper';
import { FormOutlined, MessageOutlined, PhoneOutlined } from '@ant-design/icons';

export const parseAgentWorkflows = (selectedAgent: any) => {
	if (!selectedAgent) {
		return {
			[WORKFLOW_TYPES.INTAKE]: [],
			[WORKFLOW_TYPES.SMS]: [],
			[WORKFLOW_TYPES.TRANSFER]: [],
		};
	}

	const parseWorkflowField = (fieldValue: any): any[] => {
		if (!fieldValue) {
			return [];
		}
		if (Array.isArray(fieldValue)) {
			return fieldValue;
		}
		const parsed = safeJSONParse(fieldValue, []);
		return Array.isArray(parsed) ? parsed : [];
	};

	try {
		const intakeField = (selectedAgent as any)[WORKFLOW_CONFIG[WORKFLOW_TYPES.INTAKE].agentField];
		const smsField = (selectedAgent as any)[WORKFLOW_CONFIG[WORKFLOW_TYPES.SMS].agentField];
		const transferField = (selectedAgent as any)[
			WORKFLOW_CONFIG[WORKFLOW_TYPES.TRANSFER].agentField
		];

		return {
			[WORKFLOW_TYPES.INTAKE]: parseWorkflowField(intakeField),
			[WORKFLOW_TYPES.SMS]: parseWorkflowField(smsField),
			[WORKFLOW_TYPES.TRANSFER]: parseWorkflowField(transferField),
		};
	} catch (_error) {
		return {
			[WORKFLOW_TYPES.INTAKE]: [],
			[WORKFLOW_TYPES.SMS]: [],
			[WORKFLOW_TYPES.TRANSFER]: [],
		};
	}
};

export const parseCustomWorkflows = (customWorkflows: any[]) => {
	if (!customWorkflows || customWorkflows.length === 0) {
		return {};
	}

	const customWorkflowsByType: { [key: string]: any[] } = {};

	customWorkflows.forEach((workflow) => {
		if (!workflow || !workflow.type) {
			return;
		}

		const workflowType = workflow.type;
		if (!customWorkflowsByType[workflowType]) {
			customWorkflowsByType[workflowType] = [];
		}

		const formattedWorkflow = {
			id: workflow.id,
			name: workflow.name || 'Unnamed Workflow',
			description: workflow.scenario || '',
			enabled: workflow.enabled !== false,
			isCustom: true,
			data: workflow.data || {},
		};

		customWorkflowsByType[workflowType].push(formattedWorkflow);
	});

	return customWorkflowsByType;
};

export const mergeWorkflows = (agentWorkflows: any, customWorkflowsByType: any) => {
	const mergedWorkflows = { ...agentWorkflows };

	Object.keys(customWorkflowsByType).forEach((type) => {
		if (!mergedWorkflows[type]) {
			mergedWorkflows[type] = [];
		}
		mergedWorkflows[type] = [...mergedWorkflows[type], ...customWorkflowsByType[type]];
	});

	return mergedWorkflows;
};

export const createWorkflowToggleData = (
	workflowId: string,
	workflowType: string,
	selectedWorkflow: any,
) => {
	const typeMapping: { [key: string]: string } = {
		[WORKFLOW_TYPES.INTAKE]: 'Intake Form',
		[WORKFLOW_TYPES.SMS]: 'Text',
		[WORKFLOW_TYPES.TRANSFER]: 'Call Transfer',
	};

	return {
		id: workflowId,
		type: typeMapping[workflowType] || workflowType,
		createdFor: 'Outbound',
		name: selectedWorkflow.name,
		isCustom: selectedWorkflow.isCustom || false,
	};
};

export const getSelectedWorkflowsMap = (campaignWorkflows: any[]) => {
	const selected: { [key: string]: boolean } = {};

	if (!campaignWorkflows) {
		return selected;
	}

	const workflowTypeMapping: { [key: string]: string } = {
		'Intake Form': WORKFLOW_TYPES.INTAKE,
		Text: WORKFLOW_TYPES.SMS,
		'Call Transfer': WORKFLOW_TYPES.TRANSFER,
	};

	campaignWorkflows.forEach((campaignWorkflow) => {
		const agentWorkflowType = workflowTypeMapping[campaignWorkflow.type];

		if (agentWorkflowType) {
			selected[`${agentWorkflowType}_${campaignWorkflow.id}`] = true;
		} else {
			selected[`${campaignWorkflow.type}_${campaignWorkflow.id}`] = true;
		}
	});

	return selected;
};

export const getWorkflowIcon = (type: string) => {
	switch (type) {
		case WORKFLOW_TYPES.INTAKE:
			return <FormOutlined />;
		case WORKFLOW_TYPES.SMS:
			return <MessageOutlined />;
		case WORKFLOW_TYPES.TRANSFER:
			return <PhoneOutlined />;
		default:
			return <FormOutlined />;
	}
};
